import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { TimeSheetWorklistInfo } from '../model/timesheetWorklist.model';
import { LookupInfo } from '../model/lookup.model';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TimeSheetWorklistApproveInfo } from '../model/timesheetWorklistApprove.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';

@Component({
  selector: 'app-timesheet-worklist-approve',
  templateUrl: './timesheet-worklist-approve.component.html',
  styleUrls: ['./timesheet-worklist-approve.component.css']
})
export class TimesheetWorklistApproveComponent implements OnInit {

  baseurl: string;
  isSubmitted: any;
  _EmpCode: string;
  _TimeSheetId: number;
  _Locked: boolean;
  _Override: string;
  _All: boolean;
  _AsApprover: boolean;
  element: HTMLElement;

  // Primary data
  ListTimesheetWithAccess: TimeSheetWorklistInfo[] = [];
  ListTimesheetForApproveDetail: TimeSheetWorklistApproveInfo[] = [];
  ListTimesheetForApproveDistinctDate: TimeSheetWorklistApproveInfo[] = [];
  ListOfProjectCode: string[] = [];
  IterationDate: string = "";
  Remark: string;
  RemarkHistory: SimpleTextInfo;

  // View Project
  txtViewProject = '';
  ListOfProjectCodeView: string[] = [];
  ListTimesheetForApproveDetailFiltered: TimeSheetWorklistApproveInfo[] = [];
  ListOfProjectName: string[] = [];
  ListOfProject: any[] = [];

  // Filter
  private viewAsApprover: boolean = true;

  // Loading
  displayloading: boolean = false;
  Msgloadding: string = '';


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private location: Location, private activatedRoute: ActivatedRoute, private router: Router) {
    this.baseurl = environment.base_api;
    //GlobalService.CheckPagingAccessRights();
  }

  // ngOnInit - start
  // ========================================================================================================
  async ngOnInit() {


    this._EmpCode = localStorage.getItem("EmpCode");
    this._TimeSheetId = Number(this.activatedRoute.snapshot.params.TimeSheetId);
    this._Locked = Boolean(this.activatedRoute.snapshot.params.Locked);
    this._Override = this.activatedRoute.snapshot.params.Override;
    this._All = this.activatedRoute.snapshot.params.All;
    this._AsApprover = Boolean(this.activatedRoute.snapshot.params.AsApprover);

    if (this._Override != null && this._Override != "") this._EmpCode = this._Override;

    await this.LoadTimesheetList();
  }
  // ngOnInit - end
  // ========================================================================================================

  // Primary-Data Functions - start
  // ========================================================================================================
  async LoadTimesheetList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['EmployeeCode'] = this._EmpCode;
      objectjson['Id'] = this._TimeSheetId;
      //objectjson['TimeSheetStatus'] = "3";
      //objectjson['BypassTableDisplayCondition'] = 1;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TimeSheetWorklistInfo[]>(this.baseurl + "TimeSheet/GetAccessibleTimesheetCodeById",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ListTimesheetWithAccess = data;

            if (this.ListTimesheetWithAccess.length == 0) {
              if (confirm("This timesheet is either unavailable to you or does not exist.")) {
                this.location.back();
              }
            } else {
              //setTimeout(() => { this.Loading(false, ''); }, 500);
              if (this.ListTimesheetWithAccess[0].EmployeeCode == this._EmpCode) {
                this.viewAsApprover = false;
              }
              this.LoadTimeSheetForApprove();
            }
          }
        });
    }
  }

  async LoadTimeSheetForApprove() {

    console.log('CHECK');
    console.log(this._AsApprover);
    console.log(this._Locked);

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['TimeSheetCode'] = this.ListTimesheetWithAccess[0].TimeSheetCode;
      objectjson['EmployeeCode'] = this._EmpCode;
      if (this._AsApprover == true) objectjson['GetPastApproved'] = true;
      if ((this._Override != null && this._Override != "" && this._All == null) || (this._AsApprover == true && this._Locked == true)) objectjson['TimeSheetDateStatusCode'] = 1;
      if(this.viewAsApprover == true) objectjson['ApproverCode'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<TimeSheetWorklistApproveInfo[]>(this.baseurl + "TimeSheet/GetTimeSheetForApprove",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            if(this._Locked) this.viewAsApprover = false;

            this.ListTimesheetForApproveDetail = data.map(x => {
              if (x.TimeSheetDateStatusCode == 3 && x.LeaveApplyType == "1") return { ...x, Hours: 0 };
              else { return x };
            });

            this.ListTimesheetForApproveDetailFiltered = this.ListTimesheetForApproveDetail;

            //const ids = this.ListTimesheetForApproveDetail.map(o => o.ProjectCode)
            //this.RemarkHistory = this.ListTimesheetForApproveDetail.filter(({ ProjectCode }, index) => !ids.includes(ProjectCode, index + 1))

            this.ListTimesheetForApproveDistinctDate = Array.from(new Set(this.ListTimesheetForApproveDetail.map((item: any) => item.TimeSheetDate)));

            var pendingproj = this.ListTimesheetForApproveDetail.filter(x => (x.TimeSheetDateStatusCode == 3 && x.LeaveApplyType != "1" && x.Hours > 0) || x.TimeSheetDateStatusCode == 2);

            console.log(this.ListTimesheetForApproveDetail);

            var projects = Array.from(new Set(pendingproj.map((item: any) => item.ProjectCode )));

            //this.ListOfProject = Array.from(new Set(this.ListTimesheetForApproveDetail.map((item: any) => ({Code: item.ProjectCode, Name: item.ProjectName}) )));


            for (var x = 0; x < projects.length; x++) {
              this.ListOfProjectCode.push(projects[x]);
            }

            this.ListOfProjectCodeView = [...this.ListOfProjectCode];
            this.ListOfProjectCodeView.unshift('All');
            this.txtViewProject = 'All';

            console.log(this.ListOfProjectCode);

            this.LoadTimeSheetRemark();

            setTimeout(() => { this.Loading(false, ''); }, 500);
          }
        });
    }
  }

  async LoadTimeSheetRemark() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['TimeSheetCode'] = this.ListTimesheetWithAccess[0].TimeSheetCode;
      objectjson['Remark'] = "HTML";
      if(this.viewAsApprover == true) objectjson['UpdateBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<SimpleTextInfo>(this.baseurl + "TimeSheet/GetTimeSheetRemark",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.RemarkHistory = data;
          }
        });
    }
  }

  async ApproveTimesheet() {

    let selectedcode: string[] = [];

    let checkkedProject = $('[name="checkboxprojcode"]:checked');

    let num = checkkedProject.length;
    for (var i = 0; i < num; i++) {

      let current = <HTMLInputElement>checkkedProject[i];
      selectedcode.push(current.value);
    }


    if (selectedcode.length == 0) { return; }

    //console.log(selectedcode);

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ListOfProjectCode'] =  selectedcode; // this.ListOfProjectCode;
      objectjson['TimeSheetCode'] = this.ListTimesheetWithAccess[0].TimeSheetCode;
      objectjson['EmployeeCode'] = this.ListTimesheetWithAccess[0].EmployeeCode;
      objectjson['UpdateBy'] = this._EmpCode;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<Boolean>(this.baseurl + "TimeSheet/ApproveTimeSheet",
          strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {
            console.log("Submit = " + this.isSubmitted);
            $('#ModalApproveComplete').modal();
          });
    }
  }

  async ReviseTimesheet() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ListOfProjectCode'] = this.ListOfProjectCode;
      objectjson['TimeSheetCode'] = this.ListTimesheetWithAccess[0].TimeSheetCode;
      objectjson['EmployeeCode'] = this.ListTimesheetWithAccess[0].EmployeeCode;
      objectjson['UpdateBy'] = this._EmpCode;
      objectjson['Remark'] = this.Remark;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<Boolean>(this.baseurl + "TimeSheet/ReviseTimeSheet",
          strjson, httpOptions)
        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Submit fail");
        },
          () => {
            console.log("Submit = " + this.isSubmitted);
            $('#ModalReviseComplete').modal();
          });
    }
  }

  // Primary-Data Functions - end
  // ========================================================================================================

  // OnEvent - start
  // ========================================================================================================
  OnRevise_Click() {
    this.ReviseTimesheet();
  }
  OnApprove_Click() {
    this.ApproveTimesheet();
  }
  OnBack_Click() {
    (this.viewAsApprover == true) ? this.router.navigate(["/timesheet-worklist", { Tab: "Approval"}]) : this.location.back();
  }
  OnViewProjectChange(){

    if (this.txtViewProject !== 'All') {
      this.ListTimesheetForApproveDetailFiltered = this.ListTimesheetForApproveDetail.filter(x => {
        return x.ProjectCode == this.txtViewProject || (x.TimeSheetDateStatusCode == 3 && x.LeaveApplyType == '1') || x.TimeSheetDateStatusCode == 5 || x.TimeSheetDateStatusCode == 0;
      });

     }
     else { this.ListTimesheetForApproveDetailFiltered = this.ListTimesheetForApproveDetail; }

    //  console.log(this.ListTimesheetForApproveDetailFiltered)
  }
  // OnEvent - end
  // ========================================================================================================

  // Misc functions - start
  // ========================================================================================================
  Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }
  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }
  getTodayWorkingTime(date) {
    var todayrows = this.ListTimesheetForApproveDetailFiltered.filter(x => x.TimeSheetDate.toString() == date);
    var totalhours = 0;

    todayrows.forEach((obj) => {
      totalhours += obj.Hours;
    });

    return totalhours;
  }
  getRowspan(date) {
    return this.ListTimesheetForApproveDetailFiltered.filter(x => x.TimeSheetDate.toString() == date).length;
  }
  getLeaveHours(date) {
    return this.ListTimesheetForApproveDetailFiltered.filter(x => x.TimeSheetDate.toString() == date && x.Hours != 0 && x.Hours != null).length;
  }
  setIterationDate(date) {
    this.IterationDate = date;
    return "";
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxprojcode"]').prop('checked', check);
  }

  getProjectName(projcode) {
    return this.ListTimesheetForApproveDetailFiltered.filter(x => x.ProjectCode == projcode && x.ProjectName != null && x.ProjectName != "")[0].ProjectName;
  }
  // Misc functions - end
  // ========================================================================================================
}
